/** Glossary tab ng agent (M29, LNG-001): mga termino, kasingkahulugan, protected at escalation na flag, limitasyon sa haba ng sagot. Shell created by WP-M29-SCHEMA1; keys added by WP-M29-GLOSSARY (en and fil together, no dots inside key segments). */
export const glossary = {
  tab: {
    title: "Glossary",
    subtitle:
      "Ang mga salitang ginagamit ng mga customer at ng inyong team. Tinutulungan ng mga kasingkahulugan ang agent na makilala ang termino; ang mga flag ang magpapasya kung paano ito isusulat at kailan papasok ang tao. Magagamit na ang mga pagbabago sa susunod na mensahe.",
    add: "Magdagdag ng termino",
    listLabel: "Mga termino sa glossary",
    searchLabel: "Hanapin sa glossary",
    searchPlaceholder: "Hanapin ang mga termino at kasingkahulugan",
    count_one: "{{count}} termino",
    count_other: "{{count}} termino",
    scopeAll: "Lahat ng agent",
    scopeThis: "Ang agent na ito lang",
    sourcePack: "Mula sa {{pack}} pack",
    sourceOperator: "Idinagdag ng inyong team",
    synonyms: "Isinusulat din bilang",
    edit: "I-edit ang {{term}}",
    remove: "Alisin ang {{term}}",
    loadMore: "Magpakita ng higit pang termino",
    loadError: "Hindi namin ma-load ang glossary",
    loadErrorBody: "Tingnan ang inyong koneksyon at subukan ulit.",
    readOnly: "Mababasa ninyo ang glossary pero hindi ito mababago.",
    added: "Naidagdag ang termino",
    saved: "Na-save ang termino",
    removed: "Naalis ang termino",
    deleteTitle: "Alisin ang “{{term}}”?",
    deleteBody: "Hindi na ito kikilalanin ng agent mula sa susunod na mensahe. Nakatala ang pagbabago sa audit log.",
    deleteConfirm: "Alisin ang termino",
    cancel: "Kanselahin",
    capTitle: "Haba ng sagot",
    capHint: "Panatilihin ang mga sagot sa loob ng ilang salita, sa lahat ng wika. Unang tatanggalin ang mga magalang na dagdag bago ang mga detalye.",
    capSwitch: "Limitahan ang haba ng mga sagot",
    capSwitchHint: "Kapag naka-off, ang setting ng haba ng sagot lang ang susundin ng agent.",
    capWords: "Pinakamaraming salita sa isang sagot",
    capRange: "Maglagay ng buong bilang mula {{min}} hanggang {{max}}.",
    capSave: "I-save ang limitasyon",
    capSaved: "Na-save ang limitasyon sa sagot",
    capRemoved: "Naalis ang limitasyon sa sagot",
    capCurrent: "Ngayon: hanggang {{count}} salita",
    capNone: "Ngayon: walang limitasyon",
  },
  form: {
    addTitle: "Magdagdag ng termino",
    editTitle: "I-edit ang termino",
    description: "Isang terminong dapat makilala ng agent, kasama ang iba pang paraan ng pagsulat nito.",
    term: "Termino",
    termHint: "Ayon sa gusto ninyong pagkakasulat, hanggang 80 character.",
    termRequired: "Ilagay ang termino.",
    termTooLong: "Hanggang {{max}} character ang termino.",
    locale: "Wika ng termino",
    localeOptions: { any: "Anumang wika", en: "English", fil: "Filipino", taglish: "Taglish" },
    synonyms: "Mga kasingkahulugan",
    synonymsHint: "Iba pang paraan ng pagsabi, hanggang {{max}}. Hinahanap ang bawat isa ayon sa pagkakasulat.",
    synonymText: "Kasingkahulugan {{n}}",
    synonymLocale: "Wika ng kasingkahulugan {{n}}",
    addSynonym: "Magdagdag ng kasingkahulugan",
    removeSynonym: "Alisin ang kasingkahulugan {{n}}",
    scope: "Para sa",
    save: "I-save ang termino",
    duplicate: "Nasa glossary na ang terminong ito.",
    full: "Puno na ang glossary. Mag-alis ng termino para makapagdagdag.",
    failed: "Hindi ma-save ang termino. Subukan ulit.",
  },
  flags: {
    protected: "Huwag isalin",
    protectedHint: "Isusulat nang eksakto, pati sa mga sagot sa Filipino at Taglish.",
    escalation: "Salitang nag-eescalate",
    escalationHint: "Kapag isinulat ito ng customer, mapupunta ang usapan sa tao.",
    protectedBadge: "Huwag isalin",
    escalationBadge: "Ipinapasa sa tao",
  },
  empty: {
    title: "Wala pang termino",
    body: "Idagdag ang mga salitang ginagamit ng mga customer, gaya ng pangalan ng produkto, lokal na salita at Taglish, para maintindihan at maisulat ng agent ang mga ito gaya ng sa inyo.",
    cta: "Idagdag ang unang termino",
    noMatchTitle: "Walang terminong tumutugma sa “{{query}}”",
    noMatchBody: "Sumubok ng ibang salita o burahin ang hanap.",
    clear: "Burahin ang hanap",
  },
};
